import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl" }, "No availability", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium tracking-tight text-gray-500 sm:text-2xl" }, "Try different dates", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl" }, "We found availability", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium tracking-tight text-gray-500 sm:text-2xl" }, "Choose your accommodations(s)", -1)
const _hoisted_9 = { class: "mt-12 lg:grid lg:grid-cols-12 lg:gap-x-12 lg:items-start xl:gap-x-16" }
const _hoisted_10 = {
  "aria-labelledby": "cart-heading",
  class: "lg:col-span-7"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", {
  id: "cart-heading",
  class: "sr-only"
}, "Rooms booked", -1)
const _hoisted_12 = { class: "text-lg font-normal tracking-tight text-gray-900 sm:text-lg border-b" }
const _hoisted_13 = {
  role: "list",
  class: "border-b border-gray-200 divide-y divide-gray-200"
}
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "ml-4 flex-1 flex flex-col justify-between sm:ml-6" }
const _hoisted_17 = { class: "relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "mt-4 sm:mt-0 sm:pr-9" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "name", "onUpdate:modelValue", "onChange"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "absolute top-0 right-0" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Remove", -1)
const _hoisted_28 = { class: "mt-4 flex text-xs text-gray-700 space-x-2" }
const _hoisted_29 = { role: "list" }
const _hoisted_30 = { class: "mt-2 text-teal-500" }
const _hoisted_31 = { class: "mt-4 flex text-sm text-gray-700 space-x-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Check in from 3pm - Check out by 11am", -1)
const _hoisted_33 = { class: "mt-0 flex text-sm text-gray-700 space-x-2" }
const _hoisted_34 = {
  "aria-labelledby": "summary-heading",
  class: "mt-16 bg-gray-50 rounded-lg px-4 py-6 sm:p-6 lg:p-8 lg:mt-0 lg:col-span-5"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", {
  id: "summary-heading",
  class: "text-lg font-medium text-gray-900"
}, "Booking summary", -1)
const _hoisted_36 = { class: "text-sm font-normal tracking-tight text-gray-900 mt-4" }
const _hoisted_37 = { class: "mt-6 space-y-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-600" }),
  /*#__PURE__*/_createElementVNode("dd", { class: "text-sm font-medium text-gray-900" }, "USD")
], -1)
const _hoisted_39 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-600" }, "Main House", -1)
const _hoisted_41 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_42 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_43 = { class: "text-sm text-gray-600" }
const _hoisted_44 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_45 = {
  key: 2,
  class: "flex items-center justify-between"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-green-600" }, "Entire Villa discount", -1)
const _hoisted_47 = { class: "text-sm font-medium text-green-900" }
const _hoisted_48 = {
  key: 3,
  class: "flex items-center justify-between border-t border-gray-200"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("dt", { class: "text-md text-gray-600" }, "Room subtotal", -1)
const _hoisted_50 = { class: "text-md font-medium text-gray-900" }
const _hoisted_51 = {
  key: 4,
  class: "flex items-center justify-between"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-600" }, "Extras (e.g. groceries)", -1)
const _hoisted_53 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_54 = {
  key: 5,
  class: "flex items-center justify-between border-t border-gray-200"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("dt", { class: "text-md text-gray-600" }, "Booking subtotal", -1)
const _hoisted_56 = { class: "text-md font-medium text-gray-900" }
const _hoisted_57 = {
  key: 6,
  class: "flex items-center justify-between"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-thing text-gray-600 italic" }, "Select a quantity to view summary", -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = {
  key: 7,
  class: "border-t border-gray-200 pt-4 flex items-center justify-between"
}
const _hoisted_61 = { class: "flex items-center text-sm text-gray-600" }
const _hoisted_62 = { class: "mr-2 flex-shrink-0 text-gray-400 hover:text-gray-500" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Learn more about occupancy", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", null, "Additional occupancy (per person)", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("dd", { class: "text-sm font-medium text-gray-900" }, "$10.00 / night", -1)
const _hoisted_66 = {
  key: 8,
  class: "border-t border-gray-200 pt-4 flex items-center justify-between"
}
const _hoisted_67 = { class: "flex items-center text-sm text-gray-600" }
const _hoisted_68 = { class: "mr-2 flex-shrink-0 text-gray-400 hover:text-gray-500" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Security deposit", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", null, "Security deposit for entire villa", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("dd", { class: "text-sm font-medium text-gray-900" }, "TT$2000 (US$300)", -1)
const _hoisted_72 = { class: "mt-6" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = {
  key: 0,
  class: "mt-2 text-red-300 text-sm italic"
}
const _hoisted_75 = {
  key: 1,
  class: "mt-2 text-green-800 text-sm italic"
}
const _hoisted_76 = {
  key: 1,
  class: "mt-2 text-red-300 text-sm italic"
}
const _hoisted_77 = {
  key: 2,
  class: "mt-2 text-green-800 text-sm italic"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed, reactive, ref } from "vue";
import { CheckIcon, ClockIcon, XIcon, CurrencyDollarIcon } from "@heroicons/vue/solid";
import { roomArray as rooms, roomDetails } from "@/lib/rooms";
import moment from "moment";
import { differenceInDays } from "date-fns";
import { groupBy, toArray, reduce, set as _set } from "lodash";
import { InformationCircleIcon } from "@heroicons/vue/outline";
import { Booking, Guest, Pricing, RoomDetails, RoomName, RoomTypes } from "@shared/types";
import { RoomAvailability } from "api/_lib/availability";
import TermsConditions from "./TermsConditions.vue";
import BookingRoomPreferences from "./BookingRoomPreferences.vue";
import BookingContact from "./BookingContact.vue";
import { addBooking } from "@/lib/bookings";
import { nanoid } from "@/lib/bookings";
import WhatsAppContact from "./WhatsAppContact.vue";
import { roomExtras } from "@shared/data";
import { BASE_URL_PAYMENT } from "@shared/config";

type FinalBookingOrderType = {
  booking: Booking;
  guest: Guest | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingOrder',
  props: {
  availability: { type: Array<RoomAvailability> || null },
  priceList: { type: Array<Pricing> || null },
  searchDates: { type: Array<Date> },
},
  setup(__props) {

const props = __props;



let availability = computed(() => props.availability);
let searchDates = computed(() => props.searchDates);
let priceListNice = computed(() => (roomType:any ) => {
  if (!props.priceList) return null;
  let nicer = groupBy(props.priceList,"roomType")[roomType].map((p) => `From ${moment(p.startDate).format("MMM D")} to ${moment(p.endDate).format("MMM D")} : US$${p.priceUSD}`,
  ).join(" | ");
  return nicer;
});

const hasAvailability = computed(() => {
  console.log(availability.value);
  return availability?.value?.length && searchDates?.value;
});

const getAvailableRoomsByType = (): { [key in RoomTypes]: Array<RoomAvailability[]> } => {
  let avail = availability?.value;
  // THIS SHOWS the actual availability details
  let rooms = {
    mainhouse: [groupBy(avail, "roomType").mainhouse],
    cabana: toArray(groupBy(groupBy(avail, "roomType").cabana, "room")).filter((r) => r.length == getNights.value),
  };
  // console.log("Available rooms",rooms)
  return rooms;
};

const getAvailableRoomCountByType = (): { [key in RoomTypes]: number } => {
  let avail = availability?.value;
  if (avail) {
    // this returns the count
    return {
      mainhouse: groupBy(avail, "roomType").mainhouse?.length == getNights.value ? 1 : 0,
      cabana: toArray(groupBy(groupBy(avail, "roomType").cabana, "room")).filter((r) => r.length == getNights.value)
        .length,
    };
  } else return { mainhouse: 0, cabana: 0 };
};
const entireVillaAvailable = computed(() => {
  let { mainhouse, cabana } = getAvailableRoomCountByType();
  return mainhouse == 1 && cabana == 3;
});

const getDates = computed(() => {
  return `${moment(searchDates?.value![0]).format("ddd MMM D, YYYY")} to ${moment(searchDates?.value![1]).format(
    "ddd MMM D, YYYY"
  )}`;
});
const getNights = computed(() => {
  if (searchDates?.value!.length == 2) return differenceInDays(searchDates?.value[1], searchDates?.value[0]);
  else return 0;
});


const roomConditions = (room: RoomTypes) => roomDetails[room].bookingConditions;

const roomSelected: { cabana: string; mainhouse: string } = reactive({ cabana: "0", mainhouse: "0" });

const updateBooking = (room: { type: RoomTypes; qty: number }) => {
  if (finalBooking.booking.roomDetails?.some((r) => r.room.includes(room.type))) {
    // we reduced the number of rooms desired for this type so remove reset room details
    let count = finalBooking.booking.roomDetails?.filter((r) => r.room.includes(room.type)).length;
    // console.log(`reset rooms details for ${room.type}, ${room.qty} instead of ${count}`);
    if (count > room.qty) {
      let roomsOfOtherType = finalBooking.booking.roomDetails?.filter((r) => !r.room.includes(room.type));
      let reducedOfThisType = finalBooking.booking.roomDetails
        ?.filter((r) => r.room.includes(room.type))
        .slice(0, room.qty);
      finalBooking.booking.roomDetails = [...roomsOfOtherType, ...reducedOfThisType];
    }
  }
  roomSelected[room.type] = `${room.qty}`;
  // console.log({availability: props.availability})
};
const removeRoom = (roomType: RoomTypes) => {
  // console.log(roomType);
  roomSelected[roomType] = "0";
  finalBooking.booking.roomDetails = finalBooking.booking?.roomDetails?.filter((r) => !r.room.includes(roomType));
};
const wantsEntireVilla = computed(() => {
  return roomSelected["mainhouse"] == "1" && roomSelected["cabana"] == "3";
});

const getRoomTotal = (roomType: RoomTypes) =>
  computed(() => {
    let qtyRooms = parseInt(roomSelected[roomType]);
    // Because the rooms of same type are the same price, just slice
    let init = {
      priceUSD: 0,
      priceTTD: 0,
    };
    if (!availability.value?.length) return init;

    // use the prices from the first available cabana, or the mainhouse
    let usingRooms = getAvailableRoomsByType()[roomType][0];
    // console.log({usingRooms})
    return reduce(
      usingRooms,
      (sum, a) => {
        return {
          priceUSD: sum.priceUSD + (a.priceUSD || 0) * qtyRooms,
          priceTTD: sum.priceTTD + (a.priceTTD || 0 * qtyRooms),
        };
      },
      init
    );
    // return parseInt(roomSelected[roomType]) * roomPrice[roomType] * getNights.value
  });

const getRoomSubTotalBeforeDiscount = computed(() => {
  return getRoomTotal("mainhouse").value.priceUSD + getRoomTotal("cabana").value.priceUSD;
});
const getEntireVillaDiscount = computed(() => {
  return wantsEntireVilla.value ? 0.1 * getRoomSubTotalBeforeDiscount.value : 0;
});
const getRoomSubTotal = computed(() => {
  return (
    getRoomTotal("mainhouse").value.priceUSD + getRoomTotal("cabana").value.priceUSD - getEntireVillaDiscount.value
  );
});

const selectEntireVilla = () => {
  roomSelected["mainhouse"] = "1";
  roomSelected["cabana"] = "3";
};
const finalBooking: FinalBookingOrderType = reactive({ booking: {} as Booking, guest: null as Guest | null });

const getExtrasTotal = computed(() => {
  return (
    finalBooking.booking.roomDetails?.reduce(
      (acc, curr) => {
        acc.priceUSD = acc.priceUSD + (curr.groceries ? 1 : 0) * roomExtras.gorceries.priceUSD;
        return acc;
      },
      { priceUSD: 0 }
    ) || { priceUSD: 0 }
  );
});

const getBookingSubTotal = computed(() => getRoomSubTotal.value + getExtrasTotal.value.priceUSD);

// const roomPreferences: Array<RoomDetails> = reactive([]);

const updateRoomPreferences = (event: any) => {
  // console.log(event)
  // if (!finalBooking.booking) finalBooking.booking = {};
  // need to break it out as its an object {'cabana-1': {noAdults: 1, etc}}
  // and turn into array of roomDetails
  let allRoomDetails: Array<RoomDetails> = [];
  _set(finalBooking.booking, "roomDetails", []);
  Object.keys(event).map((k) => {
    let thisRoomDetails: RoomDetails | null = null;
    let [roomType, idx] = k.split("-"); // 1, 2, 3
    // console.log({ roomType }, { idx });
    if (!idx) {
      // its not a room its another preference
      if (roomType == "_airportPickup") finalBooking.booking.airportPickup = event[k];
      return;
    }
    // get the name of the room ie cabana1 from the first date of the available rooms for that room
    let room = getAvailableRoomsByType()[roomType as RoomTypes][parseInt(idx) - 1][0].room as RoomName; // cabana1
    let { noAdults, noChildren, groceries } = event[k];
    thisRoomDetails = {
      _key: nanoid(),
      room,
      noAdults: parseInt(noAdults) || 0,
      noChildren: parseInt(noChildren) || 0,
      groceries: groceries || false,
    };
    // console.log(roomDetails);
    allRoomDetails.push(thisRoomDetails);
  });
  // console.log("ALL ROOMS", allRoomDetails);
  // make sure we aren't adding rooms we haven't selected:
  Object.keys(roomSelected).map((rs: any) => {
    let count = allRoomDetails.filter((r) => r.room.includes(rs)).length;
    let qty = parseInt(roomSelected[rs as RoomTypes]);
    let roomsOfOtherType = allRoomDetails.filter((r) => !r.room.includes(rs)) || [];
    let reducedOfThisType = allRoomDetails.filter((r) => r.room.includes(rs)).slice(0, qty) || [];
    finalBooking.booking.roomDetails = [...roomsOfOtherType, ...reducedOfThisType];
  });

  // finalBooking.booking?.roomDetails?.push()= event;
  // console.log(getAvailableRoomsByType(),event)
};

const updateBookingContact = (event: Guest) => {
  finalBooking.guest = event;
  // console.log("updateBookingContact", finalBooking.guest)
};

const canComfirmBooking = computed(() => {
  let checkCountRoomDetails =
    parseInt(roomSelected.cabana) + parseInt(roomSelected.mainhouse) == finalBooking.booking.roomDetails?.length;
  return checkCountRoomDetails && !!finalBooking.guest?.email;
});

let isConfirming = ref(false);
let bookingErrorMessage = ref("");
let bookingIsConfirmed = ref(false);
let bookingId = ref("");

const confirmAndAddBooking = () => {
  finalBooking.booking = {
    ...finalBooking.booking,
    // no using any more
    // roomsBooked: finalBooking.booking.roomDetails?.map((rd) => rd.room) || [],
    checkin: moment(searchDates?.value![0]).format("YYYY-MM-DD"),
    checkout: moment(searchDates?.value![1]).format("YYYY-MM-DD"),
    bookingRef: nanoid(),
    bookingDate: moment().toISOString(),
  };
  // console.log({ finalBooking });

  isConfirming.value = true;

  addBooking(finalBooking)
    .then((res) => {
      // console.log({ res });
      isConfirming.value = false;
      if (!res) throw Error("Could not book");
      bookingIsConfirmed.value = true;
      bookingId.value = res?._id || "";
    })
    .catch((err) => {
      console.log({ err });
      bookingErrorMessage.value = "There was an error adding your booking. Please contact us at host@topotobago.com";
      isConfirming.value = false;
    });
};

const goToPaymentPage = () => {
  window.location.href = BASE_URL_PAYMENT() + `/pay?b=${bookingId.value}`;
};

return (_ctx: any,_cache: any) => {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(hasAvailability) && _unref(availability))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_unref(availability))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("form", _hoisted_9, [
              _createElementVNode("section", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h2", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(getNights)) + " nights", 1),
                  _createTextVNode(" from " + _toDisplayString(_unref(getDates)), 1)
                ]),
                (_unref(entireVillaAvailable))
                  ? (_openBlock(), _createBlock(_component_Banner, {
                      key: 0,
                      class: "mb-2 mt-3",
                      label: _unref(wantsEntireVilla) ? 'Selected' : 'Select',
                      onSelected: selectEntireVilla
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rooms), (room, roomIdx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: room.name,
                      class: "flex py-6 sm:py-10"
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          src: room.imageSrc,
                          alt: room.imageAlt,
                          class: "w-24 h-24 rounded-md object-center object-cover sm:w-48 sm:h-48"
                        }, null, 8, _hoisted_15)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("h3", _hoisted_19, [
                                _createElementVNode("a", {
                                  href: room.href,
                                  class: "font-medium text-gray-700 hover:text-gray-800"
                                }, _toDisplayString(room.name), 9, _hoisted_20)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("label", {
                              for: `quantity-${room.type}`,
                              class: "sr-only"
                            }, "Quantity, " + _toDisplayString(room.name), 9, _hoisted_22),
                            _withDirectives(_createElementVNode("select", {
                              id: `quantity-${room.type}`,
                              name: `quantity-${room.type}`,
                              "onUpdate:modelValue": ($event: any) => ((roomSelected[room.type]) = $event),
                              class: "max-w-full rounded-md border border-gray-300 py-1.5 text-base leading-5 font-medium text-gray-700 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                              onChange: ($event: any) => (updateBooking({ type: room.type, qty: $event.target.value }))
                            }, [
                              (_openBlock(), _createElementBlock("option", {
                                value: "qty",
                                key: `${room.type}-qty`
                              }, "Qty")),
                              (_openBlock(), _createElementBlock("option", {
                                value: "0",
                                key: `${room.type}-0`
                              }, "0")),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAvailableRoomCountByType()[room.type], (qty) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: qty,
                                  key: `${roomIdx}-${qty}`
                                }, _toDisplayString(qty), 9, _hoisted_24))
                              }), 128))
                            ], 40, _hoisted_23), [
                              [_vModelSelect, roomSelected[room.type]]
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "-m-2 p-2 inline-flex text-gray-400 hover:text-gray-500",
                                onClick: ($event: any) => (removeRoom(room.type))
                              }, [
                                _hoisted_27,
                                _createVNode(_unref(XIcon), {
                                  class: "h-5 w-5",
                                  "aria-hidden": "true"
                                })
                              ], 8, _hoisted_26)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("ul", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomConditions(room.type), (item) => {
                              return (_openBlock(), _createElementBlock("li", { key: item }, [
                                _createVNode(_unref(CheckIcon), { class: "h-4 w-4 inline-block text-green-600" }),
                                _createTextVNode(" " + _toDisplayString(item), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("li", _hoisted_30, [
                              _createVNode(_component_RouterLink, {
                                to: room.href,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Accomodation Features >")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_unref(ClockIcon), {
                            class: "flex-shrink-0 h-5 w-5 text-gray-300",
                            "aria-hidden": "true"
                          }),
                          _hoisted_32
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_unref(CurrencyDollarIcon), {
                            class: "flex-shrink-0 h-5 w-5 text-gray-300",
                            "aria-hidden": "true"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_unref(priceListNice)(room.type)), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode(BookingRoomPreferences, {
                  roomSelected: roomSelected,
                  onUpdated: updateRoomPreferences
                }, null, 8, ["roomSelected"]),
                _createVNode(BookingContact, { onUpdate: updateBookingContact })
              ]),
              _createElementVNode("section", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("h3", _hoisted_36, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(getNights)) + " nights", 1),
                  _createTextVNode(" from " + _toDisplayString(_unref(getDates)), 1)
                ]),
                _createElementVNode("dl", _hoisted_37, [
                  _hoisted_38,
                  (parseInt(roomSelected['mainhouse']))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("dd", _hoisted_41, "$" + _toDisplayString(getRoomTotal("mainhouse").value.priceUSD), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (parseInt(roomSelected['cabana']))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("dt", _hoisted_43, _toDisplayString(roomSelected["cabana"]) + " Cabana(s)", 1),
                        _createElementVNode("dd", _hoisted_44, "$" + _toDisplayString(getRoomTotal("cabana").value.priceUSD), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(wantsEntireVilla))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("dd", _hoisted_47, "- $" + _toDisplayString(_unref(getEntireVillaDiscount)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(getRoomSubTotal) && _unref(getExtrasTotal).priceUSD)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("dd", _hoisted_50, "$" + _toDisplayString(_unref(getRoomSubTotal)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(getExtrasTotal).priceUSD)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("dd", _hoisted_53, "$" + _toDisplayString(_unref(getExtrasTotal).priceUSD), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(getBookingSubTotal))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("dd", _hoisted_56, "$" + _toDisplayString(_unref(getBookingSubTotal)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!parseInt(roomSelected['cabana']) && !parseInt(roomSelected['mainhouse']))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
                    : _createCommentVNode("", true),
                  (parseInt(roomSelected['cabana']))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("dt", _hoisted_61, [
                          _createElementVNode("span", _hoisted_62, [
                            _createVNode(_unref(InformationCircleIcon), {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            }),
                            _hoisted_63
                          ]),
                          _hoisted_64
                        ]),
                        _hoisted_65
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(wantsEntireVilla))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("dt", _hoisted_67, [
                          _createElementVNode("span", _hoisted_68, [
                            _createVNode(_unref(InformationCircleIcon), {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            }),
                            _hoisted_69
                          ]),
                          _hoisted_70
                        ]),
                        _hoisted_71
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(TermsConditions),
                _createElementVNode("div", _hoisted_72, [
                  (!_unref(bookingIsConfirmed))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _createVNode(_component_Button, {
                          class: "mt-6",
                          label: "Confirm booking",
                          disabled: !_unref(canComfirmBooking) || _unref(isConfirming),
                          loading: _unref(isConfirming),
                          onClick: confirmAndAddBooking
                        }, null, 8, ["disabled", "loading"]),
                        (!_unref(canComfirmBooking))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, " Add room preferences and contact details to confirm "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_75))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(bookingErrorMessage))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_unref(bookingErrorMessage)), 1))
                    : _createCommentVNode("", true),
                  (_unref(bookingIsConfirmed))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        _createTextVNode(" Your reservation is pending. You will receive an email confirmation at " + _toDisplayString(finalBooking.guest?.email) + ".", 1),
                        _hoisted_78,
                        _createTextVNode("Please pay the deposit to confirm your booking."),
                        _hoisted_79,
                        _createVNode(_component_Button, {
                          class: "mt-6",
                          label: "Pay Deposit",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPaymentPage()))
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(WhatsAppContact)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})